import {BookingTransactionStatus} from "./constants/booking-transaction-constants";

const getDisplayValue = (value: string): string => {
    return BookingTransactionStatus[value] ? BookingTransactionStatus[value].supplierInvoiceStatusGroup.label : value;
};

export default getDisplayValue;
